module.exports = __webpack_public_path__ + "img/qrcode.8171454e.jpg";